import types from '../../types';

const fees = (
  state = { loading: true, data: null, levels: null },
  { type, payload },
) => {
  switch (type) {
    case types.GET_FEES_START:
      return { ...state, loading: true };

    case types.GET_FEES_SUCCESS:
      return { data: payload.fees, levels: payload.levels, loading: false };

    case types.GET_FEES_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default fees;
